<footer>
  <div class="container-fluid">
    <div class="row">
        <div class="col-md-12 text-center">
          <!-- <p class="fs-12 text-white"> The information provided on this site and by Medical Information are not intended to provide medical advice or guidelines, but rather to empower healthcare providers, patients and caregivers to make informed decisions. Healthcare providers should use their own medical judgement when making individual treatment decisions. Patients are urged to seek medical guidance from their healthcare practitioners. </p> -->
          <p *ngIf="!(LoginStatus$ | async) as LoginStatus" class="text-white d-inline-block fs-13"><i class="fas fa-sign-out-alt fs-16"></i> &nbsp; 
             You have identified yourself as a <span class="font-weight-bold">{{profilename}}</span>. If this is incorrect, and you are not a <span class="font-weight-bold">{{profilename}}</span>, <span class="text-white d-inline-block fs-13 text-underline texthover" style="cursor: pointer;" (click)="OnNotProfileClick()"> please click here </span>
          </p>
          <!-- <p class="fs-12 text-white pt-1">
            This website may contain product details or information not accessible or applicable in other territories. You are advised to refer to your territory-specific product labeling in determining appropriate use of any {{utilityService.getPortalName()}} product. 
          </p> -->

          <p class="fs-12 text-white pt-1"> The content on this site may contain product-related information not intended for, or applicable in, other territories.  You are advised to refer to your territory-specific product labeling in determining appropriate use of any {{utilityService.getPortalName()}} product. </p>
          <p class="fs-12 text-white pt-1"> The information provided on this site and by Medical Information are not intended to provide medical advice or guidelines, but rather to empower healthcare providers, patients, and caregivers to make informed decisions. Healthcare providers should use their own medical judgement when making individual treatment decisions. Patients are urged to seek medical guidance from their healthcare practitioners. </p>
        </div>
    </div>
    <div class="row border-bottom">
      <div class="col-md-12">
          <div class="footerLinks text-center">
              <!-- <a  *ngIf="enabledFooterItems.isResources" routerLink="resources">Resources</a> -->
              <a href="https://www.mallinckrodt.com/privacy-policy" target="_blank">Privacy Policy</a>
              <!-- <a href="javascript:void(0)" (click)="openContactModal(template)">Contact Us</a> -->
              <a href="https://www.mallinckrodt.com/terms-of-use/" target="_blank">Terms of Use</a>
              <a *ngIf="enabledFooterItems.isSitemap" routerLink="sitemap">Sitemap</a>
          </div>
      </div>
    </div>
    <!-- <div class="row pt-2">
        <div class="col-md-12">
             <ul class="quicklinks">
             <a href="" class="text-white d-block fs-13 text-underline pb-2">Copyright information - © 1996-2021 {{utilityService.getPortalName()}}. All Rights Reserved</a>
             </ul>     
        </div>
    </div> -->
    <div class="row pt-2">
      <div class="col-md-10 col-12">
        <div class="row">
          <div class="col-md-3 col-12"></div>
          <div class="col-md-9 col-12">
            <p class="text-white d-block fs-13 pt-2 text-center">Copyright information - © 1996-{{copyrightCurrentYear}}
              {{utilityService.getPortalName()}}. All Rights Reserved</p>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-12">
        <p class="text-white fs-9 footer-logo">Powered by<a href="https://www.scimaxglobal.com/" target="_blank"><img
              src="./assets/images/scimax.png" alt=""></a></p>
      </div>
    </div>
  </div>
</footer>

<ng-template #template>
  <div class="modal-header">
    <h5 class="modal-title w-100 d-block">Contact Us
      <span class="mt-1 float-right fs-13" data-dismiss="modal" (click)="modalRef?.hide()"><i
          class="fas fa-times pointer"></i></span>
    </h5>
  </div>
  <div class="modal-body px-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-md-12">
          <ul class="contactUs">
            <li>
              <div class="row">
                <div class="col-md-12" *ngIf="isUS_Profile">
                  <p><span class="text-center"><i class="fas fa-phone-alt"></i></span>
                  <small>1-800-844-2830</small></p>
                  <p>
                    <small>Regular Office Hours: Monday to Friday 8:00 am - 5:30 pm ET</small>
                  </p>
                </div>
                
                <div class="col-md-12" *ngIf="!isUS_Profile">
                  <span class="text-center"><i class="fas fa-phone-alt"></i></span>
                  <small> Please locate your country-specific contact number <strong style="color: #7a8aca; cursor: pointer;" (click)="openContactDoc('Non-US_Contact_Details.docx', 'Mallinckrodt Contact Details')"> here. </strong> </small>
                </div>

                <div class="col-md-12 pt-2" *ngIf="enableReportMI">
                  <span class="text-center"><i class="fas fa-file-medical"></i></span>
                  <a href="javascript:void(0)" class="d-block fs-13" (click)="navigateTo('/request-mi')"> Submit a Medical Inquiry </a>
                </div>

              </div>
            </li>
  
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>
